import { LocaleUtils } from '@grandvisionhq/utils';

const getLocaleSwitcherMenuLabel = (fallbackLocale)=>{
    var ref;
    const selectedLocale = (ref = LocaleUtils.getLocaleFromCookie()) !== null && ref !== void 0 ? ref : fallbackLocale;
    const menuLabel = selectedLocale.substring(0, 2);
    return menuLabel.toUpperCase();
};

export { getLocaleSwitcherMenuLabel };
//# sourceMappingURL=get-locale-switcher-menu-label.js.map
